<!-- 数字范围输入组件 -->
<template>
  <div class="flex flex-row justify-start items-center input-number-range">
    <!-- 前缀 -->
    <slot name="prefix"></slot>
    <InputNumber
      :model-value="modelValue[0]"
      @change="handleChangeRange0"
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabled"
      :hide-button="hideButton"
      class="intensity-count w-auto no-focus"
      :class="inputClass"
    />
    <!-- 分隔符 -->
    <span class="px-5 text-text-3">-</span>
    <InputNumber
      :model-value="modelValue[1]"
      @change="handleChangeRange1"
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabled"
      :hide-button="hideButton"
      class="intensity-count w-auto no-focus"
      :class="inputClass"
    />
    <!-- 后缀 -->
    <slot name="suffix"></slot>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { InputNumber } from '@arco-design/web-vue';
import { getLimitedNumber } from './number';
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [0, 0]
  },
  min: {
    type: Number
  },
  max: {
    type: Number
  },
  step: {
    type: Number
  },
  disabled: {
    type: Boolean,
    default: false
  },
  hideButton: {
    type: Boolean,
    default: false
  },
  precision: {
    type: Number,
    default: 0
  },
  inputClass: {
    type: String
  }
});
const emits = defineEmits(['change']);
const handleChangeRange0 = (val) => {
  // 检查左值是否大于右值
  const value1 = props.modelValue[1];
  const { min, precision, step } = props;
  val = getLimitedNumber(val, min, step, precision);
  if (val > value1) {
    val = value1;
  }

  props.modelValue[0] = val;
  emits('change', props.modelValue);
};
const handleChangeRange1 = (val) => {
  // 检查右值是否小于左值
  const value0 = props.modelValue[0];
  const { min, precision, step } = props;
  val = getLimitedNumber(val, min, step, precision);
  if (val < value0) {
    val = value0;
  }
  props.modelValue[1] = val;
  emits('change', props.modelValue);
};
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';
.input-number-range {
  .arco-input-disabled {
    border: none;
  }
}
</style>
